module.exports = __webpack_public_path__ + "img/request-active.409cdf43.svg";